var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import * as React from "react";
const SvgSharedWithNewUser = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ width: 32, height: 32, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), /* @__PURE__ */ React.createElement("rect", { width: 32, height: 32, rx: 4, fill: "#F87B15" }), /* @__PURE__ */ React.createElement("path", { d: "M15.982 8.783A1.2 1.2 0 0 0 14.8 10v4.8H10a1.201 1.201 0 1 0 0 2.4h4.8V22a1.201 1.201 0 1 0 2.4 0v-4.8H22a1.2 1.2 0 1 0 0-2.4h-4.8V10a1.2 1.2 0 0 0-1.218-1.217Z", fill: "#fff" }));
export { SvgSharedWithNewUser as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiByeD0iNCIgZmlsbD0iI0Y4N0IxNSIvPjxwYXRoIGQ9Ik0xNS45ODIgOC43ODNBMS4yIDEuMiAwIDAgMCAxNC44IDEwdjQuOEgxMGExLjIwMSAxLjIwMSAwIDEgMCAwIDIuNGg0LjhWMjJhMS4yMDEgMS4yMDEgMCAxIDAgMi40IDB2LTQuOEgyMmExLjIgMS4yIDAgMSAwIDAtMi40aC00LjhWMTBhMS4yIDEuMiAwIDAgMC0xLjIxOC0xLjIxN1oiIGZpbGw9IiNmZmYiLz48L3N2Zz4=";
